// src/components/common/CustomInput.tsx
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../constants/colors';

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const InputLabel = styled.div`
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 4px;
`;

const StyledInput = styled.input<{ isError?: boolean }>`
  width: 100%;
  padding: 8px 12px;
  background-color: white;
  border: 1px solid ${props => props.isError ? '#d93025' : '#dee2e6'};
  border-radius: 6px;
  font-size: 14px;
  color: #212529;
  transition: all 0.2s;
  
  &:hover {
    border-color: ${props => props.isError ? '#d93025' : COLORS.PRIMARY};
  }
  
  &:focus {
    outline: none;
    border-color: ${props => props.isError ? '#d93025' : COLORS.PRIMARY};
    box-shadow: 0 0 0 3px ${props => 
      props.isError ? 'rgba(217, 48, 37, 0.15)' : 'rgba(66, 99, 235, 0.15)'};
  }
  
  &::placeholder {
    color: #adb5bd;
  }
`;

export interface CustomInputProps {
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  isError?: boolean;
  type?: string;
  className?: string;
  required?: boolean;
}

const CustomInput: React.FC<CustomInputProps> = ({
  label,
  placeholder,
  value,
  onChange,
  onKeyPress,
  isError = false,
  type = 'text',
  className,
  required = false
}) => {
  return (
    <InputContainer className={className}>
      {label && (
        <InputLabel>
          {label}
          {required && <span style={{ color: '#d93025', marginLeft: '4px' }}>*</span>}
        </InputLabel>
      )}
      <StyledInput
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        isError={isError}
        required={required}
      />
    </InputContainer>
  );
};

export default CustomInput;